import { tokens } from "../tokens";
import type { AccentName } from "../tokens";

interface SpinnerProps {
	// Diameter in px. Defaults to the grid step that matches the cap height of the label it replaces.
	size?: number;
	// Colour of the moving arc; defaults to the accent it sits on.
	accent?: AccentName;
}

// An indeterminate ring. Says a control is working; it replaces the label rather than sitting beside it.
export function Spinner({ size = tokens.space.lg, accent = "blue" }: SpinnerProps) {
	const border = Math.max(2, Math.round(size / 8));
	return (
		<span
			aria-hidden="true"
			style={{
				display: "inline-block",
				width: size,
				height: size,
				borderRadius: tokens.radius.pill,
				border: `${border}px solid ${tokens.color.stroke.hairline}`,
				borderTopColor: tokens.color.accent[accent],
				animation: `mm-spin 700ms linear infinite`,
			}}
		/>
	);
}
